import { Button, Icon, Tooltip } from 'bold-ui'
import React from 'react'

interface ErrataNotaComplementarButtonProps {
  isAcessoLotacaoCriadora: boolean
  onClick(): void
}

export function ErrataNotaComplementarButton(props: Readonly<ErrataNotaComplementarButtonProps>) {
  const { isAcessoLotacaoCriadora, onClick } = props

  const handleButtonClick = (e: Event) => {
    e.stopPropagation()
    onClick()
  }

  const handleButtonKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      e.stopPropagation()
      onClick()
    }
  }

  return (
    <Tooltip
      text={
        isAcessoLotacaoCriadora
          ? 'Registrar errata ou nota complementar'
          : 'Somente a lotação responsável pelo registro pode registrar erratas ou notas complementares'
      }
    >
      <Button
        size='small'
        skin='ghost'
        disabled={!isAcessoLotacaoCriadora}
        onClick={(e) => handleButtonClick(e)}
        onKeyDown={handleButtonKeyDown}
      >
        <Icon icon='chatOutline' size={1.5} />
      </Button>
    </Tooltip>
  )
}
